import { FC, useEffect, useState } from 'react'
import Pagination from '../../components/Pagination';
import { useHistory } from 'react-router-dom';
import { useConfirmAction } from '../../../hooks/utils/useConfirmAction';
import { handleImageErrorGray } from '../../../utils/UtilsFiles';
import SVG from 'react-inlinesvg'
import { getMyIntroductions } from '../../../services/introductionService';
import { IntroductionRequest, IntroductionRequestList } from '../models';
import { showErrorAlert } from '../../../helpers/alert';
import { DetailModal } from './modals/DetailModal';
import { formatDateShortIntl2 } from '../../../helpers/FormatDate';
import { getOrCreateConversation } from '../../../services/chatService';

interface PropsSectionUpcoming {
}

const SectionUpcoming: FC<PropsSectionUpcoming> = ({ }) => {
    const [paginationData, setPaginationData] = useState<any>(null);
    const [list, setList] = useState<IntroductionRequestList>([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedItem, setSelectedItem] = useState<IntroductionRequest>();
    const [showDetailModal, setShowDetailModal] = useState(false);
    // modal declinar
    const limit = 5;
    const history = useHistory()
    const confirm = useConfirmAction()

    useEffect(() => {
        getList();
    },[])

    const getList = async (page:number=1,offset:number=0) => {
        setIsLoading(true);
        const introductions_ = await getMyIntroductions({ section: 'upcoming', limit, offset })
        setPaginationData(introductions_);
        setList(introductions_?.results || []);
        setCurrentPage(page);
        setIsLoading(false);
    }

    const totalPages = paginationData
        ? Math.ceil(paginationData.count / limit)
        : 1;

    const handlePageChange = async (page: number) => {
        const offset = (page - 1) * limit;
        await getList(page,offset);
    };

    const handleShowDetail = (introduction:IntroductionRequest) => {
        setSelectedItem(introduction);
        setShowDetailModal(true)
    }

    const handleSendMessage = async (introduction: IntroductionRequest) => {
        try {
            const conv = await getOrCreateConversation('introduction', introduction.id);
            if (conv && conv.uuid) {
                history.push(`/messages?uuid=${conv.uuid}`);
            }
        } catch (e) {
            console.error("Error navigating to conversation:", e);
        }
    }

    return (
        <div className="tap-host-secction-experiences-past-wrapper">
            <div className={`tap-host-secction-experiences-past-list ${isLoading ? '' : 'd-none'}`}>
                <div className='loader-experience'></div>
            </div>
            <div className={`introductions-secction-wrapper-list`}>
                {(list ?? []).map((intro:IntroductionRequest, index:number) =>
                    (<div key={intro.id ?? index} className="introductions-card">

                        {/* LEFT IMAGE */}
                        <div className="introductions-card-img-wrapper cursor-pointer" onClick={()=>handleShowDetail(intro)}>
                            <img className="introductions-card-img" src={intro?.relation == "receiver" ? intro?.requester?.avatar : intro?.recipent?.avatar} onError={handleImageErrorGray} alt={intro?.requester?.username}/>

                            <div className="introductions-card-img-overlay">
                                <div className="introductions-card-img-title">
                                    {intro?.relation == "receiver" ?  intro?.requester?.username : intro?.recipent?.username }
                                </div>
                            </div>
                        </div>

                        {/* RIGHT CONTENT */}
                        <div className="introductions-card-details">

                            {/* HEADER */}
                            <div className="introductions-card-header">
                                <div className="introductions-card-header-left">
                                    <div className="introductions-card-header-label">Type</div>
                                    <div className="introductions-card-header-value">{ intro?.type || 'General Introduction' }</div>
                                </div>
                                <div className="introductions-card-header-right">
                                    <div className="introductions-card-header-date">
                                        {formatDateShortIntl2(intro?.dateRequest)}
                                    </div>
                                    <div className="introductions-card-header-expiry">
                                        <span>{intro?.status}</span>
                                    </div>
                                </div>
                            </div>

                            {/* INFO BOX */}
                            <div className="introductions-card-info-box">
                                <div className="introductions-card-info-row">
                                    <div className="introductions-card-info-label">
                                        TOPIC
                                    </div>
                                    <div className="introductions-card-info-value">
                                        {intro.topic || 'N/A'}
                                    </div>
                                </div>
                                <div className="introductions-card-info-divider"></div>
                                <div className="introductions-card-info-row">
                                    <div className="introductions-card-info-label">
                                        MESSAGE
                                    </div>
                                    <div className="introductions-card-info-content">
                                        <div className="introductions-card-info-value text-truncate-introduction">
                                            { intro.message || 'N/A' }
                                        </div>
                                        {intro?.message && intro.message.length > 120 && (
                                            <div className="introductions-card-read-more" onClick={()=>handleShowDetail(intro)}>
                                                READ MORE
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* BOTTOM ACTIONS */}
                            <div className="introductions-card-actions">
                                {intro?.status === 'ACCEPTED' && (
                                    <div 
                                        role="button" 
                                        className="introductions-card-read-more" 
                                        onClick={() => handleSendMessage(intro)}
                                    >
                                        SEND MESSAGE
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>)
                )}
            </div>
            {list.length > 0 && paginationData && (<div className='text-start mt-5'>
                <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} />
            </div>)}
            {list.length == 0 && (<div className="no-introductions">
                There is no introductions activity yet.
            </div>)}
            {showDetailModal && (<DetailModal introduction={selectedItem} open={showDetailModal} onCancel={()=>setShowDetailModal(false)} />)}
        </div>

    )
}

export { SectionUpcoming }